// Code from https://github.com/tgandrews/react-commento/blob/master/src/index.tsx
import {DiscussionEmbed} from 'disqus-react';

// const shortName = import.meta.env.DEV ? 'skiessentials-2' : 'skiessentials-1';
const shortName = 'skiessentials-2';

export function PostComments({
  id,
  title,
  link,
}: {
  id: string;
  title: string;
  link: string;
}) {
  if (link == null || id == null) {
    console.warn('PostComments: no "id" and "link" found.');
    return null;
  }

  return (
    <div className="border-t border-t-gray-300 pt-5">
      <div className="text-18/18 lg:text-28/28 font-header font-extrabold mb-[30px] lg:mb-[60px]">
        LEAVE A REPLY
      </div>
      <DiscussionEmbed
        shortname={shortName}
        config={{
          url: link,
          identifier: id,
          title,
          language: 'en_US',
        }}
      />
    </div>
  );
}
